export function getHopType(offer) {
  const raw = Number(offer['Preis Kg']) > 0;
  const alpha = Number(offer['Preis Kg Alpha'] > 0);

  return raw ? " kg Rohhopfen"
    : alpha ? " kg Alpha"
      : offer.Lieferart === 0
        ? " kg Rohhopfen" : " kg Alpha";
}
